import { useMemo } from "react";
import { motion } from "framer-motion";

// Costruisce una singola linea continua: caos (nodi sovrapposti) -> ordine (spirale)
const buildPath = () => {
  const pts = [];
  const TAU = Math.PI * 2;

  // 1) Caos — nodo di Lissajous 5:4 (molti anelli sovrapposti = traffico aggrovigliato)
  const cx = 80;
  const cy = 80;
  const ax = 56;
  const ay = 46;
  const chaosSteps = 320;
  for (let i = 0; i <= chaosSteps; i++) {
    const t = i / chaosSteps;
    const tau = TAU * t;
    const x = cx + ax * Math.sin(5 * tau + Math.PI / 4) + 7 * Math.sin(9 * tau);
    const y = cy + ay * Math.sin(4 * tau) + 7 * Math.cos(7 * tau);
    pts.push([x, y]);
  }

  // 2) Transizione — onda fluida verso la spirale
  const startX = cx + ax * Math.sin(Math.PI / 4); // ~119.6, y = 80
  const endX = 253; // punto esterno della spirale (y = 80)
  const tSteps = 60;
  for (let i = 1; i <= tSteps; i++) {
    const p = i / tSteps;
    const x = startX + (endX - startX) * p;
    const y = 80 + 24 * Math.sin(p * TAU); // onda completa, torna a 80
    pts.push([x, y]);
  }

  // 3) Ordine — spirale che converge al centro (affidabilità)
  const scx = 315;
  const scy = 80;
  const r0 = 62;
  const turns = 2.75;
  const sSteps = 280;
  for (let i = 0; i <= sSteps; i++) {
    const p = i / sSteps;
    const theta = Math.PI + p * TAU * turns;
    const r = r0 * (1 - p);
    const x = scx + r * Math.cos(theta);
    const y = scy + r * Math.sin(theta);
    pts.push([x, y]);
  }

  let d = `M ${pts[0][0].toFixed(2)} ${pts[0][1].toFixed(2)}`;
  for (let i = 1; i < pts.length; i++) {
    d += ` L ${pts[i][0].toFixed(2)} ${pts[i][1].toFixed(2)}`;
  }
  return d;
};

export const Logo = ({ className = "", strokeWidth = 2.4, animated = false }) => {
  const d = useMemo(buildPath, []);
  return (
    <svg
      viewBox="0 0 385 160"
      fill="none"
      className={className}
      aria-label="Bologna NCC"
      data-testid="brand-logo"
    >
      {animated ? (
        <motion.path
          d={d}
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={{ pathLength: 1, opacity: 1 }}
          transition={{ duration: 2.6, ease: "easeInOut" }}
        />
      ) : (
        <path
          d={d}
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
};
